<template>
  <div class="guidelines-container-div-mid">
    <h2 class="card-subtitle-irish-date mt-0">{{ subtitle }}</h2>

    <div class="p-2 input-border-grey-mid" v-if="is_view == true">
      <pre class="m-1">{{ value }}</pre>
      <div class="mt-5 w-100">
        <b-button
          variant="action"
          class="btn btn-bumblebee btn-mid mb-1 btn-edit-input-mid"
          @click="clickEdit"
        >
          Edit
        </b-button>
      </div>
    </div>
    <div v-else>

      <b-form-textarea
        class="form-control-mid"
        v-model="edit_text_model"
        :edit_text_model="edit_text_model"
        rows="10"
        >{{ edit_text_model }}</b-form-textarea
      >

      <b-row class="mt-5">
        <b-col lg="3" offset-lg="9" md="4" offset-md="8" sm="6" offset-sm="6">
          <b-button
          v-if="!is_loading"
            type="button"
            variant="mid-primary"
            class="btn-bumblebee btn-mid btn-mid-submit w-100"
            @click="saveChanges"
          >
            Save Changes
          </b-button>
            <b-button
              type="submit"
              disabled
              variant="mid-primary"
              class="w-100 btn-bumblebee btn-mid btn-mid-submit"
              v-else
            >
              <b-spinner
                small
                label="Small Spinner"
                variant="light"
              ></b-spinner>
              Loading
            </b-button>
        </b-col></b-row
      >
    </div>
  </div>
</template>

<script>

import $, { event } from "jquery";
import axios from "axios";

export default {
  name: "EditTextBlock",
  props: ["type", "subtitle", "value","id","slug"],
  components: {},
  data() {
    return {
      is_view: true,
      edit_text_model: ""+this.value,
      is_loading: false
    };
  },
  mounted(){
      this.edit_text_model = ""+this.value
  },
  methods: {
    clickEdit() {
      this.is_view = false;
       this.edit_text_model = ""+this.value
    },
    saveChanges(){
        console.log("save changes "+this.type)
        console.log(this.id, this.slug)
        console.log(this.edit_text_model)
        // this.is_view = true;
        this.is_loading = true
        if(this.id == null){
          this.sendCreateRequest()
        }else{
          this.sendUpdateRequest()
        }

    },
    sendCreateRequest(){
      console.log("in send create request ")

       let formData = new FormData();
      formData.append("client", "MID");
      formData.append("name", this.subtitle);
      formData.append("slug", this.slug);
      formData.append("text", this.edit_text_model);

       axios
        .post("cms/admin/cms-pages" , formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Data is saved successfully",
            type: "success",
            timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_view = true;
          this.is_loading = false;
          console.log(this.$parent)
          this.$parent.$parent.$parent.getData();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    sendUpdateRequest(){
      console.log("in send update request ")

      let formData = new FormData();
      formData.append("client", "MID");
      formData.append("name", this.subtitle);
      formData.append("slug", this.slug);
      formData.append("text", this.edit_text_model);
      formData.append("_method", "put");

       axios
        .post("cms/admin/cms-pages/" + this.id, formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Data is updated successfully",
            type: "success",
            timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_view = true;
          this.is_loading = false;
          console.log(this.$parent)
          this.$parent.$parent.$parent.getData();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_irish_date/manage_guidelines/EditTextBlock.vue